import { render, staticRenderFns } from "./EmailContactsTable.vue?vue&type=template&id=b8b2bc18&scoped=true"
import script from "./EmailContactsTable.vue?vue&type=script&lang=js"
export * from "./EmailContactsTable.vue?vue&type=script&lang=js"
import style0 from "./EmailContactsTable.vue?vue&type=style&index=0&id=b8b2bc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b2bc18",
  null
  
)

export default component.exports